import styled, { css, keyframes } from 'styled-components'
import { GridWrapper, GridItem } from '@sainsburys-tech/grid'
import { colorToLunaToken } from '../../../helpers/theming/utilities'
import { C008Props, C008Copy, C008Icon } from './types'

const slide = (length: number) => {
  return keyframes`
      0% {
        transform: translateX(0);
        opacity: 0;
      }
      2%, 25% {
        transform: translateX(0);
        opacity: 1;
      }
      30% {
        transform: translateX(${length === 2 ? 0 : '-200%'});
        opacity: 1;
      }
      50% {
        transform: translateX(-400%);
        opacity: 1;
      }
      55%, 75%, 80%, 100% {
        transform: translateX(-400%);
        opacity: 0;
      }
    `
}

export const StyledContainer = styled(GridWrapper)<C008Props>`
  min-height: 40px;
  margin-bottom: ${(props) => props.theme.size.spacing.lg};

  ${(props) =>
    props.isStandard &&
    css`
      border-bottom: ${props.theme.size.border.width.sm} solid ${props.theme.color.alias.border};
      padding: ${props.theme.size.spacing.md} 0;
      background-color: ${props.backgroundColor === 'grey'
        ? props.theme.color.monochrome.lighter
        : props.theme.color.monochrome.white};
    `}
`

export const StyledProposition = styled(GridItem)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${(props) => props.theme.size.spacing.md};

  ${(props) =>
    css`
      @media (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        &:first-child:not(:only-child) {
          border-right: ${props.theme.size.border.width.sm} solid ${props.theme.color.alias.border};
        }
        &:last-child:not(:only-child) {
          border-left: ${props.theme.size.border.width.sm} solid ${props.theme.color.alias.border};
        }
      }
    `}

  ${(props) =>
    !props.isStandard &&
    css`
      margin: ${props.theme.size.spacing.md} 0;
      background: ${colorToLunaToken(props.backgroundColor, props.theme) || 'transparent'};
      color: ${colorToLunaToken(props.textColor, props.theme) || props.theme.color.monochrome.darker};
    `}

    ${(props) =>
    props.mobileLayout === 'stack' &&
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        min-height: 40px;
        justify-content: start;
        width: 100%;
      }
    `}

  ${(props) =>
    props.mobileLayout === 'slide' &&
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].md}) {
        animation: ${slide(props.length)} ${props.length * 4}s infinite;
        animation-delay: ${props.index * 4}s;
        opacity: 0;
        z-index: ${props.length - props.index};
        width: 100%;
        position: absolute;
        left: 0;

        ${props.length === 1 &&
        css`
          animation: none;
          opacity: 1;
          position: unset;
        `}
      }
    `}
`

export const StyledIcon = styled.img<C008Icon>`
  margin-right: ${(props) => props.theme.size.spacing.md};
  max-width: 24px;
  flex: 0;

  ${(props) =>
    !props.isStandard &&
    css`
      padding-bottom: ${props.theme.size.spacing.md};
    `}
`

export const StyledCopy = styled.div<C008Copy>`
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    text-align: center;
  }
  ${(props) =>
    !props.isStandard &&
    css`
      padding: ${props.theme.size.spacing.lg} ${props.theme.size.spacing.md};
      text-align: center;
    `}
  p {
    margin-bottom: ${(props) => (!props.isStandard ? props.theme.size.spacing.md : 0)};
  }
`
